// Domain-level redirect to virtual.dftb26.com.
//
// Rule of thumb:
//   - Admin paths ALWAYS stay on this app (so organisers can still log in,
//     run bulk-resend, export data, etc.).
//   - Auth paths (login/forgot/reset) stay so admin can authenticate.
//   - `?stay=1` query parameter persists you on this app via localStorage,
//     so once an admin uses it they don't need to re-add it.
//   - Everything else redirects to virtual.dftb26.com.
//
// Flip REDIRECT_ENABLED to false to instantly disable the redirect without
// a redeploy (e.g. for a rollback while keeping the codebase consistent).

import { VIRTUAL_PLATFORM } from "@/lib/virtual";

export const REDIRECT_ENABLED = true;

// Paths that MUST keep working on app.dftb26.com — admin console + every
// route needed to log into it. Prefix match.
const BYPASS_PREFIXES = [
  "/admin",
  "/login",
  "/register",
  "/forgot-password",
  "/reset-password",
  "/privacy",
  "/terms",
];

const STAY_QUERY_KEY = "stay";
const STAY_QUERY_VAL = "1";
const STAY_STORAGE_KEY = "dftb26_stay_on_app";

function safeGetStayFlag() {
  try { return localStorage.getItem(STAY_STORAGE_KEY) === "1"; }
  catch { return false; }
}

function safeSetStayFlag() {
  try { localStorage.setItem(STAY_STORAGE_KEY, "1"); }
  catch { /* private mode etc */ }
}

export function shouldRedirectToVirtual() {
  if (!REDIRECT_ENABLED) return false;
  if (typeof window === "undefined") return false;

  const path = window.location.pathname || "/";
  if (BYPASS_PREFIXES.some((p) => path === p || path.startsWith(p + "/"))) return false;

  // ?stay=1 in the URL — persist and stay.
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get(STAY_QUERY_KEY) === STAY_QUERY_VAL) {
      safeSetStayFlag();
      return false;
    }
  } catch { /* malformed query — ignore */ }

  // Previously-set bypass flag.
  if (safeGetStayFlag()) return false;

  return true;
}

export function performVirtualRedirect() {
  if (typeof window === "undefined") return;
  // Use replace so the original URL doesn't pollute browser history.
  window.location.replace(VIRTUAL_PLATFORM.url);
}
